// Phase 8 Plan 03 Task 1 — per-template walker for the `ranked-tier` template.
//
// Pure TS — no React, no DOM. Server-friendly: Phase 10 AI prompt-gen + Phase 13 SSR
// re-import from here. Hand-written per RESEARCH §"Pattern 2 Option A".
//
// configSchema source mirrored verbatim (../../schemas/widget-templates/ranked-tier.ts):
//   optionSetWidgetId: string
//   tiers: ReadonlyArray<RankedTier>  — { id, label, rank, colors: { bg, border, fg } }
//
// Walker output: kind:'group' root with two children — optionSetWidgetId leaf +
// tiers array (nested per-tier group with id/label/rank leaves + nested colors
// group with bg/border/fg leaves).

import type { FieldDescriptor } from "../descriptors.js";

export function walkRankedTierConfig(configPath: string): FieldDescriptor {
  return {
    kind: "group",
    name: "config",
    path: configPath,
    children: [
      {
        kind: "leaf",
        name: "optionSetWidgetId",
        path: `${configPath}.optionSetWidgetId`,
        type: "string",
        required: true,
      },
      {
        kind: "array",
        name: "tiers",
        path: `${configPath}.tiers`,
        itemDescriptor: {
          kind: "group",
          name: "tier",
          path: `${configPath}.tiers.*`,
          children: [
            {
              kind: "leaf",
              name: "id",
              path: `${configPath}.tiers.*.id`,
              type: "string",
              required: true,
            },
            {
              kind: "leaf",
              name: "label",
              path: `${configPath}.tiers.*.label`,
              type: "string",
              required: true,
            },
            {
              kind: "leaf",
              name: "rank",
              path: `${configPath}.tiers.*.rank`,
              type: "number",
              required: true,
            },
            {
              kind: "group",
              name: "colors",
              path: `${configPath}.tiers.*.colors`,
              children: [
                {
                  kind: "leaf",
                  name: "bg",
                  path: `${configPath}.tiers.*.colors.bg`,
                  type: "string",
                  required: true,
                },
                {
                  kind: "leaf",
                  name: "border",
                  path: `${configPath}.tiers.*.colors.border`,
                  type: "string",
                  required: true,
                },
                {
                  kind: "leaf",
                  name: "fg",
                  path: `${configPath}.tiers.*.colors.fg`,
                  type: "string",
                  required: true,
                },
              ],
            },
          ],
        },
      },
    ],
  };
}
